import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CustomService } from '@/shared/services/custom.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { ConsultorioHorarioService } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-horario.service';
import { ConsultorioHorarioRequest, ConsultorioHorariosInsertRequest } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-horario.model';
import { HttpContext } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
/** Fachada de horários de atendimento do consultório privado. */
export class ConsultorioHorarioFeatureService extends CustomService {
    private readonly core = inject(ConsultorioHorarioService);

    buscar(params: Pessoa & { idConsultorio: number }): Observable<ConsultorioHorarioRequest[]> {
        return this.core.buscar(params).pipe(catchError(this.handleError));
    }

    inserirHorarios(pessoa: Pessoa, body: ConsultorioHorariosInsertRequest, context?: HttpContext): Observable<void> {
        return this.core.inserirHorarios(pessoa, body, context).pipe(catchError(this.handleError));
    }
}
